import React from 'react';
import Pagination from 'react-bootstrap/Pagination';

export const API_BASE = '/api';
export const PAGE_SIZE = 50;

export async function fetchCsrfToken() {
  const response = await fetch(`${API_BASE}/csrf/`, { credentials: 'include' });
  if (!response.ok) throw new Error('Failed to fetch CSRF token');
  const data = await response.json();
  return data.csrfToken;
}

export function TablePagination({ info, page, onPageChange }) {
  if (!info || info.count <= PAGE_SIZE) return null;
  const totalPages = Math.max(1, Math.ceil(info.count / PAGE_SIZE));
  const start = (page - 1) * PAGE_SIZE + 1;
  const end = Math.min(page * PAGE_SIZE, info.count);
  return (
    <div className="admin-pagination d-flex flex-wrap justify-content-between align-items-center gap-2 px-3 py-2">
      <div className="text-muted small">
        Showing {start}&ndash;{end} of {info.count}
      </div>
      <Pagination className="mb-0" size="sm">
        <Pagination.First disabled={page <= 1} onClick={() => onPageChange(1)} />
        <Pagination.Prev disabled={!info.hasPrev} onClick={() => onPageChange(page - 1)} />
        <Pagination.Item active>{page} / {totalPages}</Pagination.Item>
        <Pagination.Next disabled={!info.hasNext} onClick={() => onPageChange(page + 1)} />
        <Pagination.Last disabled={page >= totalPages} onClick={() => onPageChange(totalPages)} />
      </Pagination>
    </div>
  );
}
